import { useEffect } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";

/**
 * Renders a form component for adding or editing a Ethnicity Management record.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object from the antd form library.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form value changes.
 * @param {Object} props.editValues - The values to pre-populate the form with.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }
  }, [editValues, form]);

  /**
   * Process the form data and handle the form submission.
   *
   * @param {any} data - The form data to be processed.
   * @return {Promise<void>} A promise that resolves when the form submission is complete.
   */
  const onFinish = (data: any) => {
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
